import { alpha, useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

const TemplateHeader = ({ backgroundColor, textColor, bottomBorderColor, backgroundOpacity = 1, children, ...rest }) => {
  const theme = useTheme();

  // Direct mapping from provided theme:
  const paletteMapping = {
    primary: theme.palette.primary.main, // PRIMARY
    secondary: theme.palette.secondary.main, // SECONDARY
    textPrimary: theme.palette.text.primary, // TEXT
    textSecondary: theme.palette.text.secondary, // LIGHT TEXT
    complementary: theme.palette.background.paper, // COMPLEMENTARY
  };

  const headerBackgroundColor = paletteMapping[backgroundColor] ?? backgroundColor ?? "#ffffff00";
  const headerTextColor = paletteMapping[textColor] ?? textColor ?? theme.palette.text.primary;
  const headerBottomBorderColor = bottomBorderColor ? paletteMapping[bottomBorderColor] ?? bottomBorderColor : null;

  if(!backgroundColor) backgroundOpacity = 0

  return (
    <header
      {...rest}
      style={{
        backgroundColor: alpha(headerBackgroundColor, backgroundOpacity), // Apply opacity here
        color: headerTextColor,
        position: 'relative',
        zIndex: 1,
        borderBottom: headerBottomBorderColor ? `1.6px solid ${headerBottomBorderColor}` : 'none', // Add border only if bottomBorderColor is provided
      }}
    >
      {children}
    </header>
  );
};

TemplateHeader.propTypes = {
  transparent: PropTypes.bool,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  bottomBorderColor: PropTypes.string,
  children: PropTypes.node,
  backgroundOpacity: PropTypes.number,
};

export default TemplateHeader;
